import './App.css';
import Gates from './components/gates'
import Lines from './components/lines';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useState, useEffect } from 'react'
import { gateType } from './components/gate';
import Chart from './components/chart';
import _ from 'lodash'
import handleGates from "./components/HandleGates";
import { MathJaxContext } from 'better-react-mathjax'

function App() {

  const [series, setSeries] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,])
  const [categories, setCategories] = useState(['00000', '00001', '00010', '00011', '00100', '00101', '00110', '00111', '01000', '01001', '01010', '01011', '01100', '01101', '01110', '01111', '10000', '10001', '10010', '10011', '10100', '10101', '10110', '10111', '11000', '11001', '11010', '11011', '11100', '11101', '11110', '11111'])
  const [shots, setShots] = useState(2048)
  const gates = handleGates.useContainer()


  const getCSRFToken = () => {
    const csrfCookie = document.cookie.match(/csrftoken=([^ ;]+)/);
    return csrfCookie ? csrfCookie[1] : "";
  };

  const handleSubmit = async (gates: { items: gateType[], key: number }[]) => {
    // Send the form data to the Django API endpoint
    fetch('/api/submit-form', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCSRFToken(), // Include the CSRF token as a header
      },
      body: JSON.stringify({ gates: gates, shots: shots }),
    })
      .then((response) => response.json())
      .then((data) => {
        setCategories(data.x)
        setSeries(data.y)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  useEffect(() => {
    handleSubmit(gates.gates)
  }, [gates.gates, shots])

  const handleInputChange = (e: any) => {
    const value = parseInt(e.target.value);

    if (!isNaN(value) && value >= 1 && value <= 999999) {
      setShots(value);
    } else if (value > 999999) {
      setShots(999999);
    } else {
      setShots(1);
    }
  };


  return (
    <MathJaxContext>
      <div className='p-6'>
        <DndProvider backend={HTML5Backend}>
          <Gates />

          <Lines />
        </DndProvider>
        <div className='flex gap-2 items-center pt-2'>
          <label>
            Number of Shots:
          </label>
          <input max='999999' className='border border-gray-300 rounded-md p-1' value={shots} onChange={handleInputChange} type={"number"} />
        </div>
        <Chart data={{ series: series, categories: categories }} />
      </div>
    </MathJaxContext>
  );
}

export default App;
